import { render, staticRenderFns } from "./TaskCounter.vue?vue&type=template&id=b9ceebae&scoped=true&"
import script from "./TaskCounter.vue?vue&type=script&lang=js&"
export * from "./TaskCounter.vue?vue&type=script&lang=js&"
import style0 from "./TaskCounter.vue?vue&type=style&index=0&id=b9ceebae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ceebae",
  null
  
)

export default component.exports